import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Bar } from "react-chartjs-2";
import { store } from "../../redux/store";
import { setGraphResponse } from './../../redux/misc-data/misc-data.action';
const httpClient = axios.create();


class TransactionGraph extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			durationList: [
				// { value: "Select", label: "Select" },	
				{ value: "3", label: "3 months" },
				{ value: "6", label: "6 months" },
				{ value: "12", label: "1 year" }
			],
			durationSelected: '3',
			graphRes: ''
		}
	}

	durationSelect = (event) => {
		if (event.target.value == 'Select') {
			alert('Please select a duration');

		} else {
			this.setState({
				durationSelected: event.target.value
			})
			this.loadGraph(event.target.value);
		}
	}

	componentDidMount() {
		this.loadGraph('3');
	}


	loadGraph(durationSelected) {
		store.dispatch(setGraphResponse('loading'));

		var graphMonthList = [];
		var defaultMonthList = [];
		var successAmountList = [];
		var failureAmountList = [];
		var reversalAmountList = [];

		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug",
			"Sep", "Oct", "Nov", "Dec"];

		var today = new Date();
		var d;
		var month;

		for (var i1 = durationSelected - 1; i1 >= 0; i1 -= 1) {
			d = new Date(today.getFullYear(), today.getMonth() - i1, 1);
			var y = d.getFullYear().toString().substring(2, 4);
			month = monthNames[d.getMonth()];
			var values = month + " " + y;
			defaultMonthList.push(values);
		}


		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole,
		}

		var graphUrl = '/api/v1/dmt/statistics/' + this.props.agentInfo.id + '/' +
			durationSelected;

		httpClient.get(graphUrl,
			{ headers }
		).then((response) => {
			console.log('graph response' + JSON.stringify(response.data));
			const map = new Map(Object.entries(response.data.data));
			// const map = new Map(Object.entries({}));
			var itr = map.keys();

			for (var i = 0; i < map.size; i++) {
				graphMonthList.push(itr.next().value);

			}


			var newArray = [];

			for (var i = 0; i < defaultMonthList.length; i++) {
				if (!graphMonthList.includes(defaultMonthList[i])) {
					newArray.push(defaultMonthList[i]);
				}
			}


			if (newArray.length > 0) {
				for (var k = 0; k < newArray.length; k++) {

					var successAmount = 0;
					successAmountList.push(successAmount);

					var failedAmount = 0;
					failureAmountList.push(failedAmount);

					var reversalAmount = 0;
					reversalAmountList.push(reversalAmount);
				}
			}



			if (graphMonthList.length > 0) {
				for (var i = 0; i < graphMonthList.length; i++) {
					var index = defaultMonthList.indexOf(graphMonthList[i]);
					var successAmount = map.get(graphMonthList[i]).successAmount;
					//successAmountList.push(successAmount);
					successAmountList[index] = successAmount;

					var failedAmount = map.get(graphMonthList[i]).failedAmount;
					//failureAmountList.push(failedAmount);
					failureAmountList[index] = failedAmount;

					var reversalAmount = map.get(graphMonthList[i]).reversalAmount;
					// reversalAmountList.push(reversalAmount);
					reversalAmountList[index] = reversalAmount;
				}
			}

			var graphRes = {
				mapKeyList: defaultMonthList,
				successAmountList: successAmountList,
				failureAmountList: failureAmountList,
				reversalAmountList: reversalAmountList
			}



			this.setState({
				graphRes: graphRes
			})




			// this.setState({
			//     graphMapLength:	Object.keys(response.data.data).length
			// })

			this.setState({
				graphMapLength: defaultMonthList.length
			})



			store.dispatch(setGraphResponse(response.data));

		}).catch(error => {
			var data = null;
			var response = {
				data: data
			}
			store.dispatch(setGraphResponse('error'));

			console.log('graph service error...' + error);

		});
	}
	componentWillUnmount() {
	}


	render() {

		return (
			<div>
				{this.props.graphResponse != 'loading' &&
					this.props.graphResponse != null &&
					this.props.graphResponse != undefined &&
					this.props.graphResponse != '' &&
					this.props.graphResponse.data != null &&
					// Object.keys(this.props.graphResponse.data).length>0 &&
					<div class="topcard">


						<div>
							<div class="txngraph">
								<h4>Transactions Graph</h4>


								<select class="form-select" id="monthId" aria-label=""
									onChange={this.durationSelect}>

									{this.state.durationList.map(duration => (
										<option value={duration.value}
										>{duration.label}</option>
									))}

								</select>
							</div>

							<div class="grapreport">
								<Bar
									data={
										{
											labels: this.state.graphRes.mapKeyList,
											datasets: [
												{
													label: 'Success',
													data: this.state.graphRes.successAmountList,
													backgroundColor: '#75b91d',
												},
												{
													label: 'Failed',
													data: this.state.graphRes.failureAmountList,
													backgroundColor: '#f95023',
												},
												{
													label: 'Reversal',
													data: this.state.graphRes.reversalAmountList,
													backgroundColor: '#009adb',
												}
											]
										}
									}
									options={
										{
											plugins: {
												legend: { display: false },
											},
											scales: {
												x: {
													stacked: true,
												},
												y: {
													stacked: true,
													ticks: { display: false },
												},
											}
										}
									}
								/>

								{/* <canvas id="mycashback" width="400" height="183"></canvas> */}
							</div>
						</div>
					</div>
				}

				{/* {this.props.graphResponse.data!=null && 
				Object.keys(this.props.graphResponse.data).length==0 &&
				<div class="topcard">
									
									
								<div>
								<div class="txngraph">
								<h4>Transactions Graph</h4>
								
								</div>
								
								<div class="grapreport">
								No Records found
								</div>
								</div>
				</div>				
		} */}
				{this.props.graphResponse.data == null &&
					<div class="topcard">


						<div>
							<div class="txngraph">
								<h4>Transactions Graph</h4>

							</div>


							{this.props.graphResponse == 'loading' &&
								<div class="grapreport">
									{'Loading..'}
								</div>
							}
							{this.props.graphResponse == 'error' &&
								<div class="valid-error">
									{'Something went wrong!'}
								</div>
							}
							

						</div>

					</div>
				}
			</div>


		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { otpRefNo, phone, token, clientRole,agentInfo, graphResponse } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone, token, clientRole,agentInfo, graphResponse
});

export default connect(mapStateToProps, null)(TransactionGraph);
